<table [class]="getTableCssClasses()" mat-table [dataSource]="dataSource$">
  <ng-container *ngIf="enableSelection" matColumnDef="$select">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell class="pr-2 align-top" *matCellDef="let element">
      <mat-checkbox
        [checked]="selection.isSelected(element)"
        (change)="selection.toggle(element)"
      ></mat-checkbox>
    </td>
  </ng-container>
  <ng-container matColumnDef="{{ column }}" *ngFor="let column of columns">
    <th class="pr-4" mat-header-cell *matHeaderCellDef>
      {{ display(column) }}
    </th>
    <td class="pr-4 align-top" mat-cell *matCellDef="let element">
      <ng-container [ngSwitch]="type(element[column])">
        <ng-container *ngSwitchCase="'array'">
          <span
            [class]="getCellCssClasses(element)"
            *ngFor="let item of element[column]; last as isLast"
          >
            {{ item }}
            <br *ngIf="!isLast" />
          </span>
        </ng-container>
        <ng-container *ngSwitchCase="'boolean'">
          <span [class]="getCellCssClasses(element)">{{
            element[column] ? "Yes" : "No"
          }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'DateTime'">
          <span [class]="getCellCssClasses(element)">{{
            element[column] | date: "shortDate"
          }}</span>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <span
            [class]="getCellCssClasses(element)"
            *ngIf="longValueName(column); else Default"
            [matTooltip]="element[longValueName(column)]"
            matTooltipPosition="above"
            >{{ element[column] }}</span
          >
          <ng-template #Default>
            <span [class]="getCellCssClasses(element)">{{
              element[column]
            }}</span>
          </ng-template>
        </ng-container>
      </ng-container>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="allColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: allColumns"></tr>
</table>
